import { Component, Input } from '@angular/core';

/**
 * @module MijnOverzichtTemplateModule
 * @ngdoc component
 * @name MijnOverzichtTemplateComponent
 */
@Component({
    selector: 'mijn-overzicht-template-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    standalone: false
})
export class SkeletonComponent {
    @Input()
    public breadcrumb = true;

    @Input()
    public subtitle: boolean;

    @Input()
    public amount: boolean;

    @Input()
    public primaryAction: boolean;

    @Input()
    public secondaryAction: boolean;
}
